import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import $ from "jquery";
import { Editor } from '@tinymce/tinymce-react';
export default class Policy extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            apiKey: process.env.TINY,
            jwt: jwt,
            user_permission: user_permission,
            miss_su: helpers.getUserType(user_type, "su"),
            updateIsOpen: false,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            userid: user_id,
            add_title: '',
            add_content: '',
            add_content_en: '',
            add_id: ''
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.submitAdd = this.submitAdd.bind(this);
        this.closeAdd = this.closeAdd.bind(this);

        this.change = this.change.bind(this)
        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.openView();
    }

    openView() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getPolicy/', requestOptions)
                .then(res => res.json())
                .then(dataDetail => {
                    var data = dataDetail.data;
                    if (data.length > 0) {
                        this.setState({
                            add_id: data[0]._id,
                            add_title: data[0].title,
                            add_content: data[0].detail,
                            add_content_en: data[0].detail_en
                        });
                    } else {
                        this.setState({
                            add_id: "",
                            add_title: "",
                            add_content: "",
                            add_content_en: ""
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitAdd() {
        try {
            if (!this.state.add_title) {
                alert('ไม่พบข้อมูลหัวเรื่อง');
                return;
            }
    
            if (!this.state.add_content) {
                alert('ไม่พบข้อมูลรายละเอียด');
                return;
            }
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    id: this.state.add_id,
                    title: this.state.add_title,
                    detail: this.state.add_content,
                    detail_en: this.state.add_content_en,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                })
            };
    
            fetch(config.url.API_URL + '/createPolicy', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }
    closeAdd() {
        this.setState({
            add_title: '',
            add_content: '',
            add_content_en: ''
        });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.openView();
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleEditorChange = (content, editor) => {
        this.setState({
            add_content: content
        });
        console.log('Content was updated:', content);
    }

    handleEditorChangeEN = (content, editor) => {
        this.setState({
            add_content_en: content
        });
        console.log('Content was updated:', content);
    }

    handleEditorBlur = async (content, editor) => {
        const data = await editor.getContent();
        this.setState({
            add_content: data
        });
        console.log('Content was updated:', data);

    }


    render() {
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Policy</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Policy</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                </div>
                                <div className="card-body">
                                    <form id="form-submit">
                                        <div className="row mb-3">
                                            <div className="col-sm-3 text-right">หัวเรื่อง<span style={{ color: 'red' }}>*</span></div>
                                            <div className="col-sm-5">
                                                <input type="text" className="form-control" id="add_title" name="add_title" defaultValue={this.state.add_title} onChange={this.change} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-1 text-right">ภาษาไทย<span style={{ color: 'red' }}>*</span></div>
                                            <div className="col-sm-11">
                                                <Editor
                                                    apiKey={this.state.apiKey}
                                                    initialValue={this.state.add_content}
                                                    init={{
                                                        width: 'auto',
                                                        height: 300,
                                                        plugins: [
                                                            'advlist autolink link image lists preview',
                                                            'searchreplace wordcount visualblocks visualchars code media emoticons',
                                                            'table template paste help'
                                                        ],
                                                        toolbar: 'undo redo | styleselect | emoticons | bold italic | alignleft aligncenter alignright alignjustify | ' +
                                                            'bullist numlist outdent indent ' +
                                                            'forecolor backcolor',
                                                        menubar: 'edit view format tools table',
                                                        content_css: '//www.tiny.cloud/css/codepen.min.css'
                                                    }}
                                                    onBlur={this.handleEditorBlur}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-sm-1 text-right">ภาษาอังกฤษ</div>
                                            <div className="col-sm-11">
                                                <Editor
                                                    apiKey={this.state.apiKey}
                                                    initialValue={this.state.add_content_en}
                                                    init={{
                                                        width: 'auto',
                                                        height: 300,
                                                        plugins: [
                                                            'advlist autolink link image lists preview',
                                                            'searchreplace wordcount visualblocks visualchars code media emoticons',
                                                            'table template paste help'
                                                        ],
                                                        toolbar: 'undo redo | styleselect | emoticons | bold italic | alignleft aligncenter alignright alignjustify | ' +
                                                            'bullist numlist outdent indent ' +
                                                            'forecolor backcolor',
                                                        menubar: 'edit view format tools table',
                                                        content_css: '//www.tiny.cloud/css/codepen.min.css'
                                                    }}
                                                    onEditorChange={this.handleEditorChangeEN}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="card-footer">
                                    <center><div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    {(this.state.user_permission[171].permission == 1 &&
                                            <button className="btn btn-success" onClick={this.submitAdd}>บันทึก</button>
                                        )}</div></center>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}